import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_TICKET_FILTER, GET_TICKET_FILTER_SUCCESS, GET_TICKET_FILTER_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getTicketFilter({ payload }) {
  const { key, value } = payload.urlParams;

  console.log('payload', payload);
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/ticket-filters-data?filter_key=${key}&value=${value}`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_TICKET_FILTER_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_TICKET_FILTER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_TICKET_FILTER_ERROR, payload: error });
  }
}

export function* watchGetTicketFilter() {
  yield takeEvery(GET_TICKET_FILTER, getTicketFilter);
}

function* getTicketFilterSaga() {
  yield all([fork(watchGetTicketFilter)]);
}

export default getTicketFilterSaga;
